module.exports = __webpack_public_path__ + "img/1557614061390209025.1180f99d.png";